import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { catchError, map, switchMap } from 'rxjs/operators';

import {
  errorMessageParser,
  HierarchicalQuestionService,
  ShowError
} from '@ui/legacy-lib';

import {
  selfRegisterOfflineContactMutation,
  selfRegistrationConfigQuery,
  SelfRegistrationConfigResponse
} from '@ui/landlord/shared/queries';
import { Apollo } from 'apollo-angular';
import * as fromActions from './offline-self-registration.action';
import { SelfRegisterOfflineContactFail } from './offline-self-registration.action';

@Injectable()
export class OfflineSelfRegistrationEffects {
  private actions$ = inject(Actions);
  private apollo = inject(Apollo);
  private hierarchicalQuestionService = inject(HierarchicalQuestionService);

  selfRegistrationConfig$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromActions.FetchSelfRegistrationConfig),
      switchMap(({ token }) =>
        this.apollo
          .query<SelfRegistrationConfigResponse>({
            query: selfRegistrationConfigQuery,
            variables: { token }
          })
          .pipe(
            map(res => res.data.selfRegistrationConfig),
            map(res => {
              const selfRegistrationConfig = {
                ...res,
                questionsContainer: {
                  ...res.questionsContainer,
                  questions:
                    this.hierarchicalQuestionService.getAnsweredRootQuestions(
                      res.questionsContainer.questions
                    )
                }
              };
              return fromActions.FetchSelfRegistrationConfigSuccess({
                selfRegistrationConfig
              });
            }),
            catchError(error => [
              fromActions.FetchSelfRegistrationConfigFail(error)
            ])
          )
      )
    )
  );

  selfRegisterOfflineContact$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromActions.SelfRegisterOfflineContact),
      switchMap(({ payload }) =>
        this.apollo
          .mutate({
            mutation: selfRegisterOfflineContactMutation,
            variables: { contact: payload }
          })
          .pipe(
            map(() => fromActions.SelfRegisterOfflineContactSuccess()),
            catchError(error => [SelfRegisterOfflineContactFail(error)])
          )
      )
    )
  );

  failure$ = createEffect(() =>
    this.actions$.pipe(
      ofType(
        fromActions.SelfRegisterOfflineContactFail,
        fromActions.FetchSelfRegistrationConfigFail
      ),
      map(error => new ShowError(errorMessageParser(error)))
    )
  );
}
